import React from "react";
import type { UUID } from "../../../utils/uuid";
import type { Validation } from "../../../utils/validation";
import { ValidationStatus } from "../../../utils/validation";
import type { ButtonProps } from "./button";
import { Button } from "./button";

export type FormSubmitButton = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly validation?: Validation<any, any>;
    readonly validationId?: UUID;
    loading?: boolean;
    additionalCondition?: boolean;
} & ButtonProps;

export const FormSubmitButton = ({
    validationId,
    validation,
    children,
    disabled,
    additionalCondition,
    type,
    ...rest
}: FormSubmitButton): JSX.Element => {
    let effectiveDisabled = disabled;
    if (effectiveDisabled == null && validation && validationId) {
        effectiveDisabled = !validation.isValid(validationId) || additionalCondition === false;
    }

    let effectiveLoading = false;
    if (validation && validationId) {
        effectiveLoading =
            validation.getModelValidationStatus(validationId) === ValidationStatus.LOADING;
    }

    return (
        <Button
            {...rest}
            type={type ?? "submit"}
            disabled={effectiveDisabled}
            className={effectiveLoading ? "animate-pulse" : ""}
        >
            {children}
        </Button>
    );
};
